import { FC } from 'react';

import Expander from '@ingka/expander';
import SSRIcon from '@ingka/ssr-icon';
import calendarIcon from '@ingka/ssr-icon/paths/calendar';
import locationPinIcon from '@ingka/ssr-icon/paths/location-pin';
import { hasTranslation, t } from '@onlinepayments/payments-library';

import ContactInfo from '../../interfaces/ContactInfo';
import DeliveryService from '../../interfaces/DeliveryService';
import DeliveryTimeWindow from '../../interfaces/DeliveryTimeWindow';
import { getDeliveryDate, getDeliveryTimeWindow } from '../../utils/dateTimeUtils';
import { serviceIdToTransportMethodMap } from '../../utils/serviceIdToTransportMethodMap';
import { Address } from '../toolkit';

interface TimeWindowProps {
  isRangeOfDays: boolean;
  timeWindow: DeliveryTimeWindow;
  serviceItemNo: string;
}

const TimeWindow: FC<TimeWindowProps> = ({ isRangeOfDays, timeWindow, serviceItemNo }) => {
  return (
    <div className="flex mb-100" key={timeWindow.fromLocalDateTime}>
      <div className="mr-75 flex">
        <SSRIcon paths={calendarIcon} />
      </div>
      <div>
        {isRangeOfDays && <p className="mb-0">{t('order.delivery_between')}:</p>}

        {serviceIdToTransportMethodMap[serviceItemNo] === 'Parcel' && (
          <p className="mb-0">{t('order.estimated_delivery_date_header')}:</p>
        )}

        <p className="mb-0" data-testid="delivery-date">
          {getDeliveryDate(timeWindow, isRangeOfDays)}
        </p>

        {isRangeOfDays && hasTranslation('order.range_of_days_info') && (
          <Expander
            open={false}
            targetId="range-of-days-more-info"
            labelOpen={t('order.hide_info')}
            labelClosed={t('order.show_info')}
          >
            <div className="mt-100" data-testid="range-of-days-more-info-text">
              {t('order.range_of_days_info')}
            </div>
          </Expander>
        )}

        {!isRangeOfDays && <p>{getDeliveryTimeWindow(timeWindow)}</p>}
      </div>
    </div>
  );
};

interface IHomeDeliveryInfoProps {
  shippingContact: ContactInfo;
  deliveryService: DeliveryService;
}

const HomeDeliveryInfo: FC<IHomeDeliveryInfoProps> = ({
  shippingContact,
  deliveryService: { isRangeOfDays, deliveryTimeWindows, serviceItemNo },
}) => {
  return (
    <div>
      <div className="flex mb-100">
        <div className="mr-75 flex">
          <SSRIcon paths={locationPinIcon} />
        </div>

        <div>
          <p>{t('order.deliver_to_label')}</p>
          <Address {...shippingContact} />
        </div>
      </div>

      {deliveryTimeWindows.map((timeWindow) => (
        <TimeWindow
          key={serviceItemNo}
          isRangeOfDays={isRangeOfDays}
          timeWindow={timeWindow}
          serviceItemNo={serviceItemNo}
        />
      ))}
    </div>
  );
};

export default HomeDeliveryInfo;
